export const version = "1.0.2-daily-20251121-0";
export const channel = "daily";
export const gitcommit = "c96be98bd";
